import { render } from "./benefitComponent.vue?vue&type=template&id=3c6463aa"
import script from "./benefitComponent.vue?vue&type=script&lang=js"
export * from "./benefitComponent.vue?vue&type=script&lang=js"

import "./benefitComponent.vue?vue&type=style&index=0&id=3c6463aa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__